/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';

function useElementSize (props = { selector : '' }) {

  const {
    selector,
  } = props;

  const [size, setSize] = useState({ width: 0, height: 0 });
 
  useEffect(() => {
    if (!window.resizeObservers) {
      window.resizeObservers = {};
    }
    registerObserving();
    initSize();

    return () => {
      unregister();
    }
  }, []);

  function unregister () {
    window.removeEventListener('resize', resizeListener);
  }

  function registerObserving () {
    window.addEventListener('resize', resizeListener);
  }

  function initSize () {
    const el = document.querySelector(selector);
    if (el) {
      setSize({
        width: el.offsetWidth,
        height: el.offsetHeight,
      });
    } else {
      setTimeout(initSize, 100);
    }
  }

  function resizeListener (e) {
    clearTimeout(window.resizeTO);
    function debouncedResize () {
      const el = document.querySelector(selector);
      if (el) {
        setSize({
          width: el.offsetWidth,
          height: el.offsetHeight,
        });
      }
    }
    window.resizeTO = setTimeout(debouncedResize, 200);
  }


  return {
    size, 
  };
}

export default useElementSize;